/**
 * Properly capitalizes car brand names with special handling for known brands
 */
function capitalizeCarBrand(brand: string): string {
  if (!brand || typeof brand !== "string") {
    return "";
  }

  // Normalize input: trim and convert to lowercase
  const normalized = brand.trim().toLowerCase();

  // Special cases mapping for car brands that don't follow standard capitalization
  const specialCases: Record<string, string> = {
    bmw: "BMW",
    "bmw group": "BMW Group",
    mclaren: "McLaren",
    maserati: "Maserati",
    ferrari: "Ferrari",
    lamborghini: "Lamborghini",
    porsche: "Porsche",
    audi: "Audi",
    volkswagen: "Volkswagen",
    "mercedes-benz": "Mercedes-Benz",
    "mercedes benz": "Mercedes-Benz",
    "rolls-royce": "Rolls-Royce",
    "rolls royce": "Rolls-Royce",
    "aston martin": "Aston Martin",
    "aston-martin": "Aston Martin",
    "alfa romeo": "Alfa Romeo",
    "alfa-romeo": "Alfa Romeo",
    "land rover": "Land Rover",
    "land-rover": "Land Rover",
    "range rover": "Range Rover",
    "range-rover": "Range Rover",
    jaguar: "Jaguar",
    bentley: "Bentley",
    bugatti: "Bugatti",
    koenigsegg: "Koenigsegg",
    pagani: "Pagani",
    lotus: "Lotus",
    "mclaren automotive": "McLaren Automotive",
    tesla: "Tesla",
    lucid: "Lucid",
    rivian: "Rivian",
    polestar: "Polestar",
    genesis: "Genesis",
    infiniti: "Infiniti",
    acura: "Acura",
    lexus: "Lexus",
    cadillac: "Cadillac",
    lincoln: "Lincoln",
    buick: "Buick",
    chevrolet: "Chevrolet",
    ford: "Ford",
    dodge: "Dodge",
    chrysler: "Chrysler",
    jeep: "Jeep",
    ram: "RAM",
    gmc: "GMC",
    toyota: "Toyota",
    honda: "Honda",
    nissan: "Nissan",
    mazda: "Mazda",
    subaru: "Subaru",
    mitsubishi: "Mitsubishi",
    hyundai: "Hyundai",
    kia: "Kia",
    volvo: "Volvo",
    saab: "Saab",
    peugeot: "Peugeot",
    citroen: "Citroen",
    renault: "Renault",
    fiat: "Fiat",
    mini: "MINI",
    smart: "smart",
    ds: "DS",
    skoda: "Skoda",
    seat: "SEAT",
    cupra: "CUPRA",
  };

  // Check if it's a special case
  if (specialCases[normalized]) {
    return specialCases[normalized];
  }

  // Handle hyphenated brands (capitalize each part)
  if (normalized.includes("-")) {
    return normalized
      .split("-")
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join("-");
  }

  // Handle space-separated brands (capitalize each word)
  if (normalized.includes(" ")) {
    return normalized
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  // Default case: capitalize first letter
  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
}

export { capitalizeCarBrand };
